import "./App.css";
import "./styles/theme.css";
import Sidebar from "./components/commons/Sidebar";
import { useEffect, useState } from "react";
import Loreal from "./components/Projects/Loreal/Loreal";
import JavaCoffee from "./components/Projects/JavaCofee/JavaCoffee";
import Treeosk from "./components/Projects/Treeosk/Treeosk";
import ThreeJs from "./components/Projects/ThreeJS/ThreeJs";
import Loading from "./components/commons/LoadScreen";
import Diffuseur from "./components/Projects/Diffuseur/Diffuseur";

const links = [
  { name: "Java Coffee", href: "javacoffee" },
  { name: "Gala L'Oréal", href: "loreal" },
  { name: "Créateur d'interfaces", href: "treeosk" },
  { name: "Plan 3D avec Three.js", href: "threejs" },
  { name: "Diffuseur de parfum", href: "diffuser" },
];

function App() {
  const [curentContent, setCurrentContent] = useState("javacoffee");
  const [opacity, setOpacity] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App" style={isLoading ? { overflow: "hidden" } : undefined}>
      {!isLoading && (
        <>
          <Sidebar
            setOpacity={setOpacity}
            setCurrentContent={setCurrentContent}
            currentContent={curentContent}
            links={links}
          />
          <div style={{ opacity }} className="content">
            {curentContent === "javacoffee" && <JavaCoffee />}
            {curentContent === "loreal" && <Loreal />}
            {curentContent === "treeosk" && <Treeosk />}
            {curentContent === "threejs" && <ThreeJs />}
            {curentContent === "diffuser" && <Diffuseur />}
          </div>
        </>
      )}
      {isLoading && <Loading isLoading={true} />}
    </div>
  );
}

export default App;
